<!-- 供应商费用登记 -->
<template>
   <div>
      <div>
         <div class="demo-drawer__content data_action_form">
            <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
               <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="tabForm" @tabs="(val)=>{showTabs=val}">
                  <template slot="tabs" slot-scope="scope">
                     <!-- 商品信息 -->
                     <div class="table_content_box" v-if="scope.index == 0">
                        <el-form label-width="150px" id="mainInfo" class="baseForm" size="mini" :model="sendDataInfo" ref="sendDataInfo" :show-message="false"
                                 :disabled="dataActionBox.actionType>=2 && dataActionBox.actionType != 7  ? true : false ">
                           <el-row>
                              <el-form-item v-if="formOneValue.isShow==1" :label="formOneValue.showField" :id="formOneValue.entityField" :prop="formOneValue.entityField"
                                            v-for="(formOneValue,formOneKey) in scope.row.jurconfigform" :key="formOneKey" :rules="formOneValue.isRequired == 1 ? [{required: true, trigger: ['blur', 'change']}] : []"
                                            :hide-required-asterisk="formOneValue.isRequired == 1 ? true : false">
                                 <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField)"></label>
                                 <template>
                                    <df-date :isShowLong="false" @keyup.enter.native="nextFocus(formOneValue.isIndex)" v-if="formOneValue.fieldType == 'date'" v-model="sendDataInfo[formOneValue.entityField]"
                                             :isdisabled="formOneValue.isChange == 0">
                                    </df-date>
                                    <el-select v-else-if="formOneValue.entityField == 'cateName'" v-model="sendDataInfo[formOneValue.entityField]" @visible-change="(e)=>{selectChange(e,formOneValue.isIndex)}"
                                               placeholder="请选择">
                                       <el-option v-for="item in cateList" :key="item.dtId" :label="item.diName" :value="item.diValue">
                                       </el-option>
                                    </el-select>
                                    <el-tooltip v-else-if="formOneValue.fieldType == 'search'" class="item"
                                                :disabled="sendDataInfo[formOneValue.entityField]==null||sendDataInfo[formOneValue.entityField]==''?true:false || sendDataInfo[formOneValue.entityField].length<=9"
                                                effect="dark" :content="sendDataInfo[formOneValue.entityField]" placement="bottom-start">
                                       <el-input clearable v-model="sendDataInfo[formOneValue.entityField]" :ref="formOneValue.entityField" :id="formOneValue.entityField"
                                                 @keyup.enter.native="openSearch(formOneValue.searchId, formOneValue.isIndex, formOneValue.entityField,formOneValue.setField)" :disabled="formOneValue.isChange == 0">
                                          <el-button @click="openSearch(formOneValue.searchId, formOneValue.isIndex, formOneValue.entityField,formOneValue.setField)" slot="append" icon="el-icon-search"
                                                     :disabled="formOneValue.isChange == 0">
                                          </el-button>
                                       </el-input>
                                    </el-tooltip>
                                    <el-input @keyup.enter.native="nextFocus(formOneValue.isIndex)" v-else clearable v-model.trim="sendDataInfo[formOneValue.entityField]"
                                              :disabled="formOneValue.isChange == 0"></el-input>
                                 </template>
                              </el-form-item>
                           </el-row>
                        </el-form>
                     </div>
                  </template>
               </v-tabs>
            </el-card>
            <v-foot :actionType="dataActionBox.actionType" :footForm="footForm" :btnFlag="true" :sendDataInfo="sendDataInfo" @initActionBox="initActionBox" @sendDataAction="sendDataAction"
                    @showPrintPlan="showPrintPlan"></v-foot>
         </div>
      </div>
      <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :modal-append-to-body='true' :append-to-body="true">
         <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
      </el-dialog>
      <printPlan ref="printPlan"></printPlan>
   </div>

</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from "number-precision";
import SearchScheme from "../byComponents/SearchScheme.vue";
export default {
   name: "smFeeregistInitAction",
   props: ['actionData'],
   //import引入的组件需要注入到对象中才能使用
   components: {
      SearchScheme,
   },
   data() {
      //这里存放数据
      return {
         dataActionBox: {
            showStatus: false,
            openMode: "ltr" || "rtl",
            boxTitle: "新增" || "编辑",
            actionType: 0, // 0新增，1修改
         },
         sendDataInfo: {},
         showTabs: "费用信息",
         formDataList: [],
         seId: "",
         seWidth: "",
         seTitle: "",
         seWidth: "",
         DialogVisible: false,
         seType: "",
         sField: "",
         smId: "",
         parentSearchData: {},
         mxHeight: 0,
         tabForm: [],
         mxForm: [],
         footForm: [],
         inputel: [],
         cateList: [], //费用登记项目
      };
   },
   //监听属性 类似于data概念
   computed: {},
   //监控data中的数据变化
   watch: {
   },
   //方法集合
   methods: {
      // 主表单select框切换enter切换焦点事件方法
      selectChange(e, index) {
         if (e == false) {
            this.nextFocus(index);
         }
      },
      // 获取主表单所有input
      getMainInput() {
         var el = document.getElementById('mainInfo')
         if (el) this.inputel = el.getElementsByTagName('input')
      },
      // 初始化焦点
      initFocus() {
         for (let index = 0; index < this.inputel.length; index++) {
            if (this.inputel[index].value == '' && this.inputel[index].disabled == false) {
               this.inputel[index].focus()
               break
            }
         }
      },
      // 输入框切换焦点
      nextFocus(index) {
         if (index >= (this.inputel.length - 1)) return
         if (this.inputel[index].value == "") {
            this.inputel[index].focus()
            return
         }
         var aindex = index + 1
         if (this.inputel[aindex].value != '' || this.inputel[aindex].disabled) {
            this.nextFocus(aindex)
            return
         }
         this.inputel[aindex].focus()
      },
      showPrintPlan() { // 打印方法
         // 调用全局方法 判断Websocket是否连接
         if (this.$printSocketApi.printExeMsg() != false) {
            // 选中的数据
            this.$refs.printPlan.openDia(this.actionData.orderId, this.actionData.printSouce, this.actionData
               .printJurId)
         } else {
            return
         }
      },
      toDetail(orderId) {
         if (this.dataActionBox.actionType != 2) this.$parent.$parent.toDetail(orderId)
         else this.$parent.$parent.$parent.toDetail(orderId)
      },
      getSeWidth(e) {
         this.seWidth = e + "%";
      },
      getWidth(e) {
         this.exWidth = e + "%";
      },
      getSearchName(e) {
         this.seTitle = e;
      },
      //检索Id, 索引(表格中), 标识
      openSearch(sId, index, type, sField) {
         this.DialogVisible = true;
         this.seId = sId;
         this.seIndex = index;
         this.seType = type;
         this.sField = sField;
         this.parentSearchData[type] = this.sendDataInfo[type]
      },
      // 赋值字段
      paramValue(val) {
         let arr = this.sField.split(',')
         arr.forEach(item => {
            this.sendDataInfo[item] = val[item]
         })
         this.$nextTick(() => {
            this.nextFocus(this.seIndex)
         })
      },
      changeInputModel(val) {
         if (val != "" || val != undefined) {
            this.paramValue(val);
            this.DialogVisible = false;
         }
      },

      initActionBox(sendDataInfo) {
         this.dataActionBox.actionType = 0;
         this.$emit('drawerCancel')
         this.init();
         this.$refs[sendDataInfo].resetFields();
      },
      init() {
         for (let key in this.sendDataInfo) {
            this.sendDataInfo[key] = "";
         }
      },
      openBox() {
         this.dataActionBox.actionType = this.actionData.cate
         this.formDataList = this.actionData.formData;
         var oldData = this.actionData.oldData
         this.showTabs = this.actionData.formData[0].jciName;
         this.filterMainField()
         if (this.dataActionBox.actionType == 0) {
            this.dataActionBox.boxTitle = "新增信息";
            this.dataActionBox.openMode = "ltr";
            this.sendDataInfo.ofrTime = this.$moment().valueOf();
         } else if (this.dataActionBox.actionType == 1) {
            this.dataActionBox.boxTitle = "编辑信息";
            this.dataActionBox.openMode = "rtl";
            for (let key in oldData) {
               this.sendDataInfo[key] = oldData[key];
            }
         } else {
            this.dataActionBox.boxTitle = '查看信息'
            var dataInfo = JSON.parse(JSON.stringify(oldData))
            for (let key in dataInfo) {
               this.sendDataInfo[key] = dataInfo[key]
            }
         }
         this.$nextTick(() => {
            this.initFocus()
         })
      },
      sendDataAction(sendDataInfo) {
         this.$refs[sendDataInfo].validate((valid) => {
            if (valid) {
               this.sub();
            } else {
               return this.$message({
                  message: "请完善必填信息",
                  type: "error",
               });
            }
         });
      },
      async sub() {
         let sendData = JSON.parse(JSON.stringify(this.sendDataInfo));
         var responseData;
         if (this.dataActionBox.actionType === 0) {
            responseData = await this.$http.smfeeregistadd(sendData);
         } else if (this.dataActionBox.actionType === 1) {
            responseData = await this.$http.smfeeregistupdate(sendData);
         }
         if (responseData.status == 200) {
            this.$message({
               message: "操作成功",
               type: "success",
            });
            this.$emit('drawerCancel', true)
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
      // 过滤表单不同类型
      filterMainField() {
         var mainFormList = [];
         this.formDataList.forEach((item) => {
            if (item.jciType == 1) {
               mainFormList.push(item);
            } else if (item.jciType == 2) {
               this.mxForm = JSON.parse(JSON.stringify(item.jurconfigform));
            } else if (item.jciType == 3) {
               this.footForm = JSON.parse(JSON.stringify(item.jurconfigform));
            }
         });
         mainFormList.forEach((key, i) => {
            this.tabForm[i] = JSON.parse(JSON.stringify(key));
            this.tabForm[i].jurconfigform = [];
            for (let index = 0; index < key.jurconfigform.length; index++) {
               if (key.jurconfigform[index].isShow == 1)
                  this.tabForm[i].jurconfigform.push(key.jurconfigform[index]);
            }
         });
         this.tabForm.forEach(item => {
            var index = 0
            item.jurconfigform.forEach((val, key) => {
               if (val.isShow == 1) {
                  val.isIndex = index
                  index++
               }
            })
         })
         var obj = this.$common.filterMainFields(this.formDataList, [], mainFormList[0]);
         for (let key in obj) {
            this.$set(this.sendDataInfo, key, obj[key]);
         }

      },
      async queryCate() {
         var responseData = await this.$http.getCateDictionariesData({ids: [66]});
         if (responseData.status == 200) {
            this.cateList = responseData.result
         } else {
            this.$message({
               message: '获取登记项目异常',
               type: "error",
            });
         }
      },
   },
   //生命周期 - 创建完成（可以访问当前this实例）
   created() {
      this.$nextTick(() => {
         this.openBox()
         this.queryCate()
      })
   },
   //生命周期 - 挂载完成（可以访问DOM元素）
   mounted() { },
   beforeCreate() { }, //生命周期 - 创建之前
   beforeMount() { }, //生命周期 - 挂载之前
   beforeUpdate() { }, //生命周期 - 更新之前
   updated() {
      this.getMainInput()
   }, //生命周期 - 更新之后
   beforeDestroy() { }, //生命周期 - 销毁之前
   destroyed() { }, //生命周期 - 销毁完成
   activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_button_box {
   height: 200px;
   background-color: red;
}

.table_content_box {
   /* height: 500px !important; */
   overflow-y: auto;
}

.el-row {
   display: flex;
   flex-wrap: wrap;
   padding-right: 20px;
}

.foot {
   display: flex;
   justify-content: center;
   align-items: center;
   width: 100%;
   background: #fff;
   padding: 14px 0;
   z-index: 999;
}

.foot .el-form {
   margin-left: 20px;
}

.foot .el-form .el-form-item {
   margin-bottom: 0;
}

.el-drawer {
   outline: none;
}

.mb {
   margin-bottom: 0;
}

.newInput {
   height: 28px;
   line-height: 28px;
   background-color: #fff;
   background-image: none;
   border-radius: 4px;
   border: 1px solid #dcdfe6;
   box-sizing: border-box;
   color: #606266;
   display: inline-block;
   font-size: inherit;
   outline: 0;
   padding: 0 15px;
   transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
   width: 100%;
}
</style>